import React, { useState, useContext } from "react";

import { useForm } from "react-hook-form";
import { ConfirmCancel } from "../modal/dashboard/ConfirmCancel";
import { getUserInfoFromSession } from "../../adapters/session/localSessionAdapter";
import { updateHouseDetailsAPI } from "../../adapters/dashboard/dashboardAdapater";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { Slider } from "antd";

import { Controller } from "react-hook-form";
import { onlyNumber, maxFloorNumber } from "../common/validationFn";
import DashboardContext from "../../context/dashboard/DashboardContext";
import { Spinner } from "reactstrap";
export function MoveHouseDetails(props) {
  //house details components
  const { moveData, editDisabled } = props;
  const [showEdit, setShowEdit] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const context = useContext(DashboardContext);
  const {
    handleSubmit,
    register,
    control,
    setValue,
    getValues,
    errors,
    watch,
  } = useForm();
  const getElevatorStatus = (status) => {
    return status === "Yes" ? "Yes" : "No";
  };
  const getDistanceUnitType = (distance) => {
    const distanceGroup = distance.trim().split(" ");
    const unit = distanceGroup[distanceGroup.length - 1];
    return unit === "meters" ? "meters" : "feet";
  };
  const getFloorNo = (floorNo) => {
    return typeof floorNo === "string" ? parseInt(floorNo) : floorNo;
  };
  const getDistance = (distance) => {
    const distanceGroup = distance.trim().split(" ");
    return distanceGroup[0];
  };

  const [progress, setProgress] = useState(false);
  const [error, setError] = useState(null);

  //old house state
  const oldHouseFloorNo = getFloorNo(moveData["old_floor_no"]);

  const oldHouseDistance = getDistance(moveData["old_parking_distance"]);
  const [oldHouseElevatorStatus, updateOldHouseElevatorStatus] = useState(
    getElevatorStatus(moveData["old_elevator_availability"])
  );

  const [oldHouseDistanceUnit, updateOldHouseDistanceUnit] = useState(
    getDistanceUnitType(moveData["old_parking_distance"])
  );

  const [oldHouseDistanceSettings, setOldHouseDistanceSettings] = useState(
    getUnitSettings(getDistanceUnitType(moveData["old_parking_distance"]))
  );

  //new house state
  const newHouseFloorNo = getFloorNo(moveData["new_floor_no"]);
  const newHouseDistance = getDistance(moveData["new_parking_distance"]);

  const [newHouseElevatorStatus, updateNewHouseElevatorStatus] = useState(
    getElevatorStatus(moveData["new_elevator_availability"])
  );
  const [newHouseDistanceUnit, updateNewHouseDistanceUnit] = useState(
    getDistanceUnitType(moveData["new_parking_distance"])
  );
  const [newHouseDistanceSettings, setNewHouseDistanceSettings] = useState(
    getUnitSettings(getDistanceUnitType(moveData["new_parking_distance"]))
  );

  const formatter = (value) => parseInt(value);

  function getUnitSettings(unitType) {
    if (unitType === "meters") {
      return {
        min: 0,
        max: 100,
        step: 1,
      };
    }
    if (unitType === "feet") {
      return {
        min: 0,
        max: 328.084,
        step: 0.01,
      };
    }
  }
  const incrementFloorNumberFn = (floorNoRefKey) => {
    const floorNumber = parseInt(getValues(floorNoRefKey));
    if (floorNumber === "") {
      setValue(floorNoRefKey, 0);
      return;
    }
    if (floorNumber >= 300) {
      return;
    }
    setValue(floorNoRefKey, parseInt(floorNumber) + 1);
  };
  const decrementFloorNumberFn = (floorNoRefKey) => {
    const floorNumber = parseInt(getValues(floorNoRefKey));

    if (floorNumber === "") {
      setValue(floorNoRefKey, 0);
      return;
    }
    if (floorNumber === 0) {
      return;
    }
    setValue(floorNoRefKey, parseInt(floorNumber) - 1);
  };

  const updateDistanceSettings = (distanceRefKey, unit) => {
    let distance = getValues(distanceRefKey);
    const rangePreset =
      distanceRefKey === "old_house_distance"
        ? oldHouseDistanceSettings
        : newHouseDistanceSettings;

    if (unit === "meters") {
      //convert feet to meters
      distance = parseFloat(distance / 3.281);
      distance = distance.toFixed(2);
      rangePreset.min = 0;
      rangePreset.max = 100;
      rangePreset.step = 1;
    } else if (unit === "feet") {
      // convert meters to feet
      distance = parseFloat(distance * 3.281);
      distance = distance.toFixed(2);
      rangePreset.min = 0;
      rangePreset.max = 328.084;
      //100m = 328.084ft max value
      rangePreset.step = 0.01;
    }
    if (distanceRefKey === "old_house_distance") {
      updateOldHouseDistanceUnit(unit);
      setValue("old_house_distance", distance);
      setOldHouseDistanceSettings(rangePreset);
    } else if (distanceRefKey === "new_house_distance") {
      updateNewHouseDistanceUnit(unit);
      setValue("new_house_distance", distance);
      setNewHouseDistanceSettings(rangePreset);
    }
  };

  const submitFn = async (data) => {
    setProgress(true);
    const userSession = getUserInfoFromSession();
    const userId = userSession["userId"];
    let body = {};
    if (moveData["service_type"] === "relocation") {
      body = {
        service_type: moveData["service_type"],
        estimate_id: moveData["estimate_id"],
        user_id: userId,
        old_floor_no: data["old_house_floor_number"],
        old_elevator_availability: oldHouseElevatorStatus,
        old_parking_distance:
          data["old_house_distance"] + " " + oldHouseDistanceUnit.trim(),
        new_floor_no: data["new_house_floor_number"],
        new_parking_distance:
          data["new_house_distance"] + " " + newHouseDistanceUnit.trim(),
        new_elevator_availability: newHouseElevatorStatus,
        update_from_customer: "1",
      };
    } else if (moveData["service_type"] === "storage") {
      body = {
        service_type: moveData["service_type"],
        estimate_id: moveData["estimate_id"],
        user_id: userId,
        old_floor_no: data["old_house_floor_number"],
        old_elevator_availability: oldHouseElevatorStatus,
        old_parking_distance:
          data["old_house_distance"] + " " + oldHouseDistanceUnit.trim(),
        new_floor_no: moveData["new_floor_no"],
        new_parking_distance: moveData["new_parking_distance"],
        new_elevator_availability: moveData["new_elevator_availability"],
        update_from_customer: "1",
      };
    }
    try {
      const res = await updateHouseDetailsAPI(body);
      if (res.data.status === 200) {
        //successfully updated.
        setProgress(false);
        setShowEdit(false);
        setConfirmCancel(false);
        context.updateStatus({
          status: "success",
          color: "success",
          message: "House Details Updated Successfully!",
        });
        context.refresh();
      } else {
        context.updateStatus({
          status: "error",
          color: "danger",
          message: "An Error Occurred!",
        });
        setProgress(false);
        setError("An Error Occurred");
      }
    } catch (e) {
      setProgress(false);
      setError("An Error Occurred");
      console.error("An Error occurred", e);
    }
  };
  const oldFloorNoValue = watch("old_house_floor_number", oldHouseFloorNo);
  const newFloorNoValue = watch("new_house_floor_number", newHouseFloorNo);

  const houseDetailsJSX = (
    <>
      <div className="mb-3">
        <h6 className="heading-label active-text">Existing House Details</h6>
        <HouseInfo
          floorNo={moveData.old_floor_no}
          distanceToTruck={moveData.old_parking_distance}
          hasElevator={moveData.old_elevator_availability}
        />
      </div>
      {moveData["service_type"] === "relocation" && (
        <div className="mb-3">
          <h6 className="heading-label active-text">New House Details</h6>
          <HouseInfo
            floorNo={moveData.new_floor_no}
            distanceToTruck={moveData.new_parking_distance}
            hasElevator={moveData.new_elevator_availability}
          />
        </div>
      )}
    </>
  );
  const JSX = (
    <>
      <div className="move-house-details-container">
        <div className="d-flex flex-row align-items-center justify-content-between my-4">
          <h3 className="m-0 mr-2">House Details</h3>
          {editDisabled === false && showEdit === false && (
            <>
              <button
                className="btn btn-dark btn-sm"
                type="button"
                onClick={() => {
                  setShowEdit(true);
                }}
              >
                Edit House Details
              </button>
            </>
          )}
        </div>
        {showEdit === false && houseDetailsJSX}
        {showEdit === true && (
          <>
            <>
              <form onSubmit={handleSubmit(submitFn)}>
                <div className="house-detials-container">
                  <div className="mb-4">
                    <h6 className="heading-label active-text mb-3">
                      Existing House Details
                    </h6>
                    <div className="row">
                      <div className="col-sm-12 col-md-3 dashboard-form-element-spacing">
                        <h6 className="heading-label">Floor No.</h6>
                        <div className="input-group w-50">
                          <div className="input-group-prepend">
                            <button
                              type="button"
                              className="btn-sm clear-btn-white-theme"
                              onClick={() => {
                                decrementFloorNumberFn(
                                  "old_house_floor_number"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </button>
                          </div>
                          <input
                            type="text"
                            name="old_house_floor_number"
                            className="form-control text-center qty-input border-0"
                            defaultValue={oldHouseFloorNo}
                            autoComplete="off"
                            id="old_floor_no"
                            ref={register({
                              required: true,
                              validate: {
                                onlyNumber: onlyNumber,
                                maxFloorNumber: maxFloorNumber,
                              },
                            })}
                          />
                          <div className="input-group-append">
                            <button
                              className="btn-sm clear-btn-white-theme"
                              onClick={() => {
                                incrementFloorNumberFn(
                                  "old_house_floor_number"
                                );
                              }}
                              type="button"
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>
                        </div>
                        <span className="error-text">
                          {errors.old_house_floor_number &&
                            errors.old_house_floor_number.type === "required" &&
                            "This field is required."}
                          {errors.old_house_floor_number &&
                            errors.old_house_floor_number.type ===
                              "onlyNumber" &&
                            "Please enter only number."}
                          {errors.old_house_floor_number &&
                            errors.old_house_floor_number.type ===
                              "maxFloorNumber" &&
                            "Max allowed is 300."}
                        </span>
                      </div>
                      <div className="col-sm-12 col-md-3 dashboard-form-element-spacing">
                        <h6 className="heading-label">Elevator Available.</h6>
                        <div>
                          <div
                            className="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              className={
                                "btn btn-primary btn-sm yes-btn" +
                                (oldHouseElevatorStatus === "Yes"
                                  ? " active"
                                  : "")
                              }
                            >
                              <input
                                type="radio"
                                name="old_elevator_availability"
                                value="Yes"
                                autoComplete="off"
                                onChange={(e) => {
                                  updateOldHouseElevatorStatus("Yes");
                                }}
                                checked={
                                  oldHouseElevatorStatus === "Yes"
                                    ? true
                                    : false
                                }
                              />
                              Yes
                            </label>
                            <label
                              className={
                                "btn btn-primary btn-sm no-btn" +
                                (oldHouseElevatorStatus === "No"
                                  ? " active"
                                  : "")
                              }
                            >
                              <input
                                type="radio"
                                name="old_elevator_availability"
                                value="No"
                                autoComplete="off"
                                onChange={(e) => {
                                  updateOldHouseElevatorStatus("No");
                                }}
                                checked={
                                  oldHouseElevatorStatus === "No"
                                    ? " active"
                                    : ""
                                }
                              />
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 dashboard-form-element-spacing">
                        <h6 className="heading-label">
                          {parseInt(oldFloorNoValue) === 0
                            ? "Distance from Door to Truck."
                            : "Distance from Elevator / Staircase to truck"}{" "}
                        </h6>
                        <div className="d-flex align-items-center position-relative">
                          <div id="newHouseSlider" className="slider w-100">
                            <Controller
                              control={control}
                              name="old_house_distance"
                              defaultValue={oldHouseDistance}
                              render={(props) => (
                                <Slider
                                  min={oldHouseDistanceSettings.min}
                                  max={oldHouseDistanceSettings.max}
                                  onChange={props.onChange}
                                  value={props.value}
                                  step={oldHouseDistanceSettings.step}
                                  disabled={false}
                                  tooltipVisible={true}
                                  tipFormatter={formatter}
                                />
                              )}
                            />
                          </div>
                          <div
                            className="btn-group btn-group-toggle ml-4"
                            data-toggle="buttons"
                          >
                            <label
                              className={
                                "btn btn-primary btn-sm yes-btn" +
                                (oldHouseDistanceUnit === "feet"
                                  ? " active"
                                  : "")
                              }
                            >
                              <input
                                type="radio"
                                name="old_parking_dist_unit"
                                className="oldDistanceFormat"
                                value="feet"
                                autoComplete="off"
                                checked={
                                  oldHouseDistanceUnit === "feet" ? true : false
                                }
                                onChange={() => {
                                  // props.handleUnitsUpdateForNewFloor(e);
                                  // updateDistanceUnit("feet");
                                  updateDistanceSettings(
                                    "old_house_distance",
                                    "feet"
                                  );
                                }}
                              />
                              Ft
                            </label>
                            <label
                              className={
                                "btn btn-primary btn-sm no-btn" +
                                (oldHouseDistanceUnit === "meters"
                                  ? " active"
                                  : "")
                              }
                            >
                              <input
                                type="radio"
                                name="old_parking_dist_unit"
                                className="oldDistanceFormat"
                                value="meters"
                                autoComplete="off"
                                checked={
                                  oldHouseDistanceUnit === "meters"
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  updateDistanceSettings(
                                    "old_house_distance",
                                    "meters"
                                  );
                                }}
                              />
                              Mts
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {moveData.service_type === "relocation" && (
                    <div className="mb-4">
                      <h6 className="heading-label active-text mb-3">
                        New House Details
                      </h6>
                      <div className="row">
                        <div className="col-sm-12 col-md-3 dashboard-form-element-spacing">
                          <h6 className="heading-label">Floor No.</h6>
                          <div className="input-group w-50">
                            <div className="input-group-prepend">
                              <button
                                type="button"
                                className="btn-sm clear-btn-white-theme"
                                onClick={() => {
                                  decrementFloorNumberFn(
                                    "new_house_floor_number"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </button>
                            </div>
                            <input
                              type="number"
                              min="0"
                              name="new_house_floor_number"
                              className="form-control text-center qty-input border-0"
                              defaultValue={newHouseFloorNo}
                              autoComplete="off"
                              id="new_floor_no"
                              ref={register({
                                required: true,
                                validate: {
                                  onlyNumber: onlyNumber,
                                  maxFloorNumber: maxFloorNumber,
                                },
                              })}
                            />
                            <div className="input-group-append">
                              <button
                                className="btn-sm clear-btn-white-theme"
                                onClick={() => {
                                  incrementFloorNumberFn(
                                    "new_house_floor_number"
                                  );
                                }}
                                type="button"
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </button>
                            </div>
                          </div>
                          <span className="error-text">
                            {errors.new_house_floor_number &&
                              errors.new_house_floor_number.type ===
                                "required" &&
                              "This field is required."}
                            {errors.new_house_floor_number &&
                              errors.new_house_floor_number.type ===
                                "onlyNumber" &&
                              "Please enter only number."}
                            {errors.new_house_floor_number &&
                              errors.new_house_floor_number.type ===
                                "maxFloorNumber" &&
                              "Max allowed is 300."}
                          </span>
                        </div>
                        <div className="col-sm-12 col-md-3 dashboard-form-element-spacing">
                          <h6 className="heading-label">Elevator Available.</h6>
                          <div>
                            <div
                              className="btn-group btn-group-toggle"
                              data-toggle="buttons"
                            >
                              <label
                                className={
                                  "btn btn-primary btn-sm yes-btn" +
                                  (newHouseElevatorStatus === "Yes"
                                    ? " active"
                                    : "")
                                }
                              >
                                <input
                                  type="radio"
                                  name="new_elevator_availability"
                                  value="Yes"
                                  autoComplete="off"
                                  onChange={(e) => {
                                    updateNewHouseElevatorStatus("Yes");
                                  }}
                                  checked={
                                    newHouseElevatorStatus === "Yes"
                                      ? true
                                      : false
                                  }
                                />
                                Yes
                              </label>
                              <label
                                className={
                                  "btn btn-primary btn-sm no-btn" +
                                  (newHouseElevatorStatus === "No"
                                    ? " active"
                                    : "")
                                }
                              >
                                <input
                                  type="radio"
                                  name="new_elevator_availability"
                                  value="No"
                                  autoComplete="off"
                                  onChange={(e) => {
                                    updateNewHouseElevatorStatus("No");
                                  }}
                                  checked={
                                    newHouseElevatorStatus === "No"
                                      ? " active"
                                      : ""
                                  }
                                />
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 dashboard-form-element-spacing">
                          <h6 className="heading-label">
                            {parseInt(newFloorNoValue) === 0
                              ? "Distance from Door to Truck."
                              : "Distance from Elevator / Staircase to truck"}{" "}
                          </h6>
                          <div className="d-flex align-items-center position-relative">
                            <div id="newHouseSlider" className="slider w-100">
                              <Controller
                                control={control}
                                name="new_house_distance"
                                defaultValue={newHouseDistance}
                                render={(props) => (
                                  <Slider
                                    min={newHouseDistanceSettings.min}
                                    max={newHouseDistanceSettings.max}
                                    onChange={props.onChange}
                                    value={props.value}
                                    step={newHouseDistanceSettings.step}
                                    disabled={false}
                                    tooltipVisible={true}
                                    tipFormatter={formatter}
                                  />
                                )}
                              />
                            </div>
                            <div
                              className="btn-group btn-group-toggle ml-4"
                              data-toggle="buttons"
                            >
                              <label
                                className={
                                  "btn btn-primary btn-sm yes-btn" +
                                  (newHouseDistanceUnit === "feet"
                                    ? " active"
                                    : "")
                                }
                              >
                                <input
                                  type="radio"
                                  name="new_parking_dist_unit"
                                  className="newDistanceFormat"
                                  value="feet"
                                  autoComplete="off"
                                  checked={
                                    newHouseDistanceUnit === "feet"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    updateDistanceSettings(
                                      "new_house_distance",
                                      "feet"
                                    );
                                  }}
                                />
                                Ft
                              </label>
                              <label
                                className={
                                  "btn btn-primary btn-sm no-btn" +
                                  (newHouseDistanceUnit === "meters"
                                    ? " active"
                                    : "")
                                }
                              >
                                <input
                                  type="radio"
                                  name="new_parking_dist_unit"
                                  className="newDistanceFormat"
                                  value="meters"
                                  autoComplete="off"
                                  checked={
                                    newHouseDistanceUnit === "meters"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    updateDistanceSettings(
                                      "new_house_distance",
                                      "meters"
                                    );
                                  }}
                                />
                                Mts
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {error !== null && <div className="error-text">{error}</div>}
                <div className="d-flex mt-2 justify-content-center">
                  <button
                    type="submit"
                    disabled={progress === true ? true : false}
                    className="btn btn-sm btn-primary"
                  >
                    {progress === true && (
                      <>
                        {" "}
                        <Spinner size={"sm"} /> Saving{" "}
                      </>
                    )}
                    {progress === false && <> Save </>}
                  </button>
                  <button
                    className="btn btn-dark btn-sm ml-2"
                    onClick={() => {
                      setConfirmCancel(true);
                    }}
                    type="button"
                    disabled={progress === true ? true : false}
                  >
                    Back
                  </button>
                </div>
              </form>
            </>
            <ConfirmCancel
              onYes={() => {
                handleSubmit(submitFn)();
              }}
              progress={progress}
              onNo={() => {
                setShowEdit(false);
                setConfirmCancel(false);
              }}
              modal={confirmCancel}
              promptText={
                "House details has not been saved. Do you want to save?"
              }
            />
          </>
        )}
      </div>
    </>
  );
  return JSX;
}

export function HouseInfo(props) {
  const { floorNo, distanceToTruck, hasElevator } = props;
  const JSX = (
    <div className="row">
      <div className="col-sm-12 col-md-3 mb-1">
        <h6 className="heading-label">Floor No.</h6>
        <div className="house-data">{floorNo}</div>
      </div>
      <div className="col-sm-12 col-md-3 mb-1">
        <h6 className="heading-label">Elevator Available.</h6>
        <div className="house-data">{hasElevator}</div>
      </div>
      <div className="col-sm-12 col-md-6 mb-1">
        <h6 className="heading-label">
          {parseInt(floorNo) === 0
            ? "Distance from Door to Truck."
            : "Distance from Elevator / Staircase to truck"}{" "}
        </h6>
        <div className="house-data">{distanceToTruck}</div>
      </div>
    </div>
  );
  return JSX;
}
